import Swal from "sweetalert2";
import { config } from "./CommonURLS";
import { CommonAxiosPost } from "./CommonAxios";
import { failureAlert } from "./SweetAlerts";


export function allowAlphabetAndSpacesOnly(e) {
  var keyCode = e.charCode || e.keyCode;
  if (!((keyCode >= 65 && keyCode <= 90) || (keyCode >= 97 && keyCode <= 122) || keyCode === 32)) {
    e.preventDefault();
  }
}



export default function allowNumbersOnly(e) {
  var keyCode = e.keyCode === 0 ? e.charCode : e.keyCode;
  var value = Number(e.target.value + e.key) || 0;
  if (keyCode >= 48 && keyCode <= 57) {
    return isValidNumber(value);
  } else {
    e.preventDefault();
  }
  return false;
}

export const formatIndianNumber = (num) => {
  if (num == null || num === "") return "-";
  return Number(num).toLocaleString("en-IN");
};

export function allowFloatNumbers2(e) {
  const key = e.key;
  const currentValue = e.target.value;

  if (key === 'Backspace' || key === 'Delete' || key === 'ArrowLeft' || key === 'ArrowRight' || key === 'Tab') {
    return;
  }
  if ((key >= '0' && key <= '9') || key === '.') {
    if (currentValue.includes('.') && key === '.') {
      e.preventDefault();
      return;
    }

    if (key === '.' && currentValue.length === 0) {
      e.preventDefault();
      return;
    }

  } else {
    e.preventDefault();
  }
}
const handleBlur = (e) => {
  const newValue = e.target.value;
  if (!isValidNumber(newValue)) {
    e.target.value = '';
  }
};

const isValidNumber = (value) => {
  const number = Number(value);
  return number >= 1 && number <= 10;
};

export function handleKeyPress(e) {
  const maxLength = 10;
  const currentValue = e.target.value;
  if (currentValue.length >= maxLength) {
    e.preventDefault();
    return;
  }
  const upperCaseChar = e.key.toUpperCase();
  e.target.value += upperCaseChar;
  e.preventDefault();
}


export function allowNumbersOnlyDot(e) {
  var keyCode = e.charCode || e.keyCode;
  const inputValue = e.target.value;
  if ((keyCode >= 48 && keyCode <= 57) || keyCode === 46) {
    const newValue = inputValue + e.key;
    if (isValidNumberr(newValue)) {
      return true;
    }
  }
  e.preventDefault();
  return false;
}

const isValidNumberr = (value) => {
  const regex = /^(\d+(\.\d*)?)?$/;
  const number = parseFloat(value);

  return regex.test(value) && number >= 1 && number <= 10;
};
export function allowAlphabetAndSpacesCapitalise(e) {
  var keyCode = e.charCode || e.keyCode;

  if (!((keyCode >= 65 && keyCode <= 90) || (keyCode >= 97 && keyCode <= 122) || keyCode === 32)) {
    e.preventDefault();
  } else {
    if (keyCode >= 97 && keyCode <= 122) {
      var upperCaseChar = String.fromCharCode(keyCode - 32);
      e.target.value += upperCaseChar;
      e.preventDefault();  // Prevent default input
    }
  }
}
export function allowNumbersAndAlphabetsOnly(e) {
  var keyCode = e.charCode || e.keyCode;

  if (!(
    (keyCode >= 48 && keyCode <= 57) ||
    (keyCode >= 65 && keyCode <= 90) ||
    (keyCode >= 97 && keyCode <= 122)
  )) {
    e.preventDefault();
  }
}

export function handleAutoCapitalizeallowNumAlphat(event) {
  let inputValue = event.target.value;

  inputValue = inputValue.replace(/[^a-zA-Z0-9 ]/g, '');

  inputValue = inputValue.replace(/[a-z]/g, (match) => match.toUpperCase());

  event.target.value = inputValue;
}




export function AllowFloats(e, percentage) {
  const keyCode = e.charCode || e.keyCode;
  const inputValue = e.target.value;

  // Helper functions
  const isNumberKey = (keyCode) => keyCode >= 48 && keyCode <= 57;
  const isDecimalPointKey = (keyCode) => keyCode === 46;
  const isInputTooLong = (inputValue) => inputValue.length >= 13;
  const hasDecimalPoint = (inputValue) => inputValue.includes('.');
  const hasTooManyDigitsBeforeDecimal = (inputValue) => inputValue.split('.')[0].length >= 13;
  const hasTooManyDigitsAfterDecimal = (inputValue) => inputValue.split('.')[1]?.length >= 5;
  const isInvalidInput = (inputValue) => inputValue === '' || inputValue[0] === '.';

  // Handle decimal point input
  const handleDecimalPoint = (e, inputValue) => {
    if (hasDecimalPoint(inputValue) || isInvalidInput(inputValue)) {
      e.preventDefault();
      return false;
    }
    return true;
  };

  // Handle normal number input
  const handleNumberInput = (e, inputValue) => {
    if (hasTooManyDigitsBeforeDecimal(inputValue)) {
      e.preventDefault();
      return false;
    }

    if (hasTooManyDigitsAfterDecimal(inputValue)) {
      e.preventDefault();
      return false;
    }

    if (isInputTooLong(inputValue)) {
      e.preventDefault();
      return false;
    }

    return true;
  };

  // If percentage flag is set, apply percentage-specific rules
  if (percentage) {
    if (isNumberKey(keyCode) || isDecimalPointKey(keyCode)) {
      if (isDecimalPointKey(keyCode)) {
        return handleDecimalPoint(e, inputValue);
      } else {
        return handleNumberInput(e, inputValue);
      }
    }
  }

  // Apply common validation for numeric input
  if (isNumberKey(keyCode) || isDecimalPointKey(keyCode)) {
    if (isDecimalPointKey(keyCode)) {
      return handleDecimalPoint(e, inputValue);
    } else {
      return handleNumberInput(e, inputValue);
    }
  }

  // Default case: prevent invalid input
  e.preventDefault();
  return false;
}



export function handlePaste(e) {
  e.preventDefault();
  const pastedText = e.clipboardData.getData('text');

  // Match a number with optional decimal point and digits
  if (/^[0-9]+(\.[0-9]+)?$/.test(pastedText)) {
    document.execCommand('insertText', false, pastedText);
  } else {
    Swal.fire({
      text: 'Enter only numbers.',
      icon: 'info',
      backdrop: false,
      confirmButtonText: 'OK',
    });
  }
}













export function handleTestPaste(e) {
  e.preventDefault();
  const pastedText = e.clipboardData.getData('text');

  // Check if the pasted text is "test" (case-sensitive or not based on your need)
  if (pastedText === 'test') {
    document.execCommand('insertText', false, pastedText); // Allow pasting "test"
  } else if (/[^a-zA-Z\s]/.test(pastedText)) {
    // If pasted text contains numbers or special characters
    Swal.fire({
      text: 'Only text (letters and spaces) are allowed.',
      icon: 'info',
      backdrop: false,
      confirmButtonText: 'OK',
    });
  } else {
    document.execCommand('insertText', false, pastedText); // Allow pasting other text
  }
}




export const preventZeroInputAndPaste = (e) => {
  const inputField = e.target;
  const currentValue = inputField.value;
  const inputType = e.type;

  // Handle typing
  if (inputType === 'keypress') {
    const char = String.fromCharCode(e.which);

    // Allow digits 0–9, but block 0 as the first character
    if (!/^\d$/.test(char)) {
      e.preventDefault();
      Swal.fire({
        icon: 'error',
        text: 'Only numbers are allowed!',
      });
    } else if (currentValue === '' && char === '0') {
      e.preventDefault();
      Swal.fire({
        icon: 'error',
        text: 'Leading zero is not permitted!',
      });
    }
  }

  // Handle paste
  if (inputType === 'paste') {
    const pastedValue = e.clipboardData.getData('Text');

    if (!/^\d+$/.test(pastedValue)) {
      // Case 1: Contains non-numeric characters
      e.preventDefault();
      Swal.fire({
        icon: 'error',
        text: 'Only numbers are allowed!',
      });
    } else if (currentValue === '' && pastedValue.startsWith('0')) {
      // Case 2: Starts with 0 when pasting into empty input
      e.preventDefault();
      Swal.fire({
        icon: 'error',
        text: 'Leading zero is not permitted!',
      });
    }
  }
};

// export const reportHeadingMap = {
//   eop: "Extension of Permission (EoP)",
//   management: "Management Change",
//   shifting: "Shifting of the Institution",
//   new_college: "New College",
// };

// export const getReportHeader = (
//   baseTitle,
//   type,
//   headingMap = reportHeadingMap
// ) => {
//   return `${baseTitle}${type && headingMap[type]
//     ? ` - ${headingMap[type]}`
//     : ""
//     }`;
// };



// export const initiateESign = async ({
//   nocType,
//   collCode,
//   // apiEndpoint,
//   backtoscreen,
//   successCallback,

// }) => {
//   Swal.fire({
//     icon: "question",
//     title: "Do you want to proceed with E-Sign confirmation?",
//     showCancelButton: true,
//     confirmButtonText: "Yes",
//     cancelButtonText: "No",
//     backdrop: false,
//   }).then(async (result) => {
//     if (!result.isConfirmed) return;

//     try {
//       console.log("apptype")
//       const url = `${config.url.FAC_URL}$jd-confirmation-esign?noctype=${nocType}&collCode=${collCode}&apptype=${backtoscreen}`;
//       const res = await CommonAxiosPost(url);
//       if (res?.data?.scode === "01") {
//         const response = await Swal.fire({
//           text: res?.data?.sdesc,
//           icon: "success",
//           backdrop: true,
//           allowOutsideClick: false,
//           allowEnterKey: false,
//           allowEscapeKey: false,
//           confirmButtonText: "OK",
//         });

//         if (response.isConfirmed) {
//           if (successCallback) {
//             successCallback(res);
//           } else {
//             window.location.href = res?.data?.navEsignUrl;
//           }
//         }
//       } else {
//         failureAlert(res?.data?.sdesc);
//       }
//     } catch (error) {
//       console.error("E-Sign Error:", error);
//       failureAlert("Something went wrong. Please try again.");
//     }
//   });
// };

export const initiateESign = ({ nocType, collCode, backtoscreen, successCallback }) => {
  Swal.fire({
    icon: "question",
    title: "Do you want to proceed with E-Sign confirmation?",
    showCancelButton: true,
    confirmButtonText: "Yes",
    cancelButtonText: "No",
    backdrop: false,
  }).then(async (result) => {
    if (!result.isConfirmed) return;

    try {
      const url =
        config.url.FAC_URL +
        "jd-confirmation-esign?noctype=" +
        nocType +
        "&collCode=" +
        collCode +
        "&apptype=" +
        backtoscreen;

      const res = await CommonAxiosPost(url);

      if (res?.data?.scode === "01") {
        await Swal.fire({
          text: res?.data?.sdesc,
          icon: "success",
          confirmButtonText: "OK",
          backdrop: true,
        });

        if (successCallback) {
          successCallback(res);
        } else {
          window.location.href = res?.data?.navEsignUrl;
        }
      } else {
        failureAlert(res?.data?.sdesc);
      }
    } catch (error) {
      console.error("E-Sign Error:", error);
      failureAlert("Something went wrong. Please try again.");
    }
  });
};


export const getServiceFullName = (shortName, services = []) => {
  return (
    services.find(
      (service) => service.nos_short_name === shortName
    )?.full_name || shortName
  );
};
export const NOC_FULL_NAME_MAP = {
  eop: "Extension of Permission (EoP)",
  shifting: "Shifting of the Institution",
  change_of_inst_name: "Change of Institution Name",
  merge_ofinstructions: "Merger of Institutions",
  type_converstions: "Conversion of the Institution",
  closure_of_institutions: "Closure of Institution",
  society_name_change: "Trust / Society Name Change",
  intake_changes: "Programme / Intake Changes",
  management: "Management Change",
  new_program: "New Program",
  conversion_program: "Conversion of Program",
  additional_sec: "Additional Section",
  close_course: "Closure of Course",
};

export const getNocFullName = (nocType) =>
  NOC_FULL_NAME_MAP[nocType] || nocType;